import { render, staticRenderFns } from "./ServeFeeEdit.vue?vue&type=template&id=d75fa802"
import script from "./ServeFeeEdit.vue?vue&type=script&lang=js"
export * from "./ServeFeeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports